import process from "process";

export default function publicPath(url) {
  const publicUrl = process.env.PUBLIC_URL || "";
  return publicUrl + "/" + url;
}
